export default __webpack_public_path__ + "static/media/stopped-on.a4565ba5.svg";